var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9889V19.1135H2.2606V9.7825C2.2606 8.10078 2.77966 6.61382 3.81779 5.32163C4.85571 4.02945 6.18833 3.20297 7.81565 2.8422V2.06313C7.81565 1.629 7.96749 1.25989 8.27115 0.95581C8.57482 0.651937 8.94351 0.5 9.37722 0.5C9.81115 0.5 10.1804 0.651937 10.4849 0.95581C10.7896 1.25989 10.9419 1.629 10.9419 2.06313V2.8422C12.5692 3.20297 13.9019 4.02945 14.9398 5.32163C15.9779 6.61382 16.497 8.10078 16.497 9.7825V19.1135H18.7576V20.9889H0ZM9.3766 24.5C8.75447 24.5 8.22259 24.2787 7.78095 23.836C7.33911 23.3933 7.11819 22.8611 7.11819 22.2394H11.6394C11.6394 22.8632 11.4178 23.3959 10.9747 23.8375C10.5316 24.2792 9.99893 24.5 9.3766 24.5ZM4.13636 19.1135H14.6212V9.7825C14.6212 8.33483 14.1094 7.09923 13.0859 6.07569C12.0622 5.05194 10.8265 4.54007 9.37879 4.54007C7.93112 4.54007 6.69541 5.05194 5.67166 6.07569C4.64813 7.09923 4.13636 8.33483 4.13636 9.7825V19.1135Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.842dbccfd2470b64c5d4d7a2e8760ca4.svg";
export { ForwardRef as ReactComponent };